import axios from 'axios'
import axiosRetry from 'axios-retry'

export default function (options) {
  const client = axios.create(options)
  axiosRetry(client, {
    // retryCondition (error) {
    //   // error.code === 'ECONNABORTED' // Retry timed out requests
    // }
  })
  return client
}



// WEBPACK FOOTER //
// ./src/helpers/create-axios-instance.js